'use client';

import { useTagManager } from '@/hooks/useTagManager';

interface SearchAnalyticsProps {
  searchExpression: string;
}

export default function SearchAnalytics({ searchExpression }: SearchAnalyticsProps) {
  const decodedSearchExpression = decodeURIComponent(searchExpression);

  useTagManager({
    event: 'search',
    payload: {
      searchPhrase: decodedSearchExpression,
    },
    condition: !!decodedSearchExpression,
  });

  return null;
}
